import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Button,
  Divider,
} from '@mui/material';
import {
  YouTube as TwitchIcon,
  CalendarToday as CalendarIcon,
  SportsEsports as GameIcon,
} from '@mui/icons-material';

const CrazyTownProject: React.FC = () => {
  return (
    <Box>
      {/* Header avec titre et image */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <img
          src="/Twitch/CrazyTown.png"
          alt="Logo CrazyTown"
          style={{
            width: '64px',
            height: '64px',
            objectFit: 'contain',
            filter: 'drop-shadow(2px 2px 4px rgba(167, 139, 250, 0.3))',
          }}
        />
        <Typography
          variant="h4"
          component="h2"
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          CrazyTown
        </Typography>
      </Box>

      {/* Statut et date */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CalendarIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            2023
          </Typography>
        </Box>
      </Box>

      {/* Description */}
      <Typography
        variant="body1"
        sx={{ mb: 3, lineHeight: 1.6 }}
      >
        Intégration développée pour le serveur Minecraft RP "CrazyTown"
        créé par le youtuber/streamer Mastu. Le système affiche en temps réel
        les tweets contenant le hashtag "#crazytown" directement dans le jeu
        via des écrans intégrés, permettant aux streamers de lire et réagir
        aux messages de leurs viewers pendant leurs sessions RP.
      </Typography>

      <Divider sx={{ my: 3 }} />

      {/* Fonctionnalités principales */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Fonctionnalités principales
        </Typography>
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 2
        }}>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Affichage tweets en temps réel
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Intégration dans Minecraft via écrans
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Hashtag tracking "#crazytown"
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Interface web responsive
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Système de modération automatique
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Filtrage contenu haineux/raciste
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              • Mise à jour temps réel
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Technologies */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Technologies utilisées
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {['Express.js', 'React', 'Twitter API', 'Node.js', 'WebSocket', 'Minecraft Integration'].map((tech) => (
            <Chip
              key={tech}
              label={tech}
              variant="filled"
              size="small"
              sx={{
                background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.1) 0%, rgba(20, 184, 166, 0.1) 100%)',
                color: '#a78bfa',
                border: '1px solid rgba(167, 139, 250, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, rgba(167, 139, 250, 0.2) 0%, rgba(20, 184, 166, 0.2) 100%)',
                },
              }}
            />
          ))}
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Défis techniques */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            background: 'linear-gradient(135deg, #a78bfa 0%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: 'bold'
          }}
        >
          Défis techniques relevés
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Modération automatique avancée :</strong> Mise en place d'un système
          de filtrage intelligent utilisant l'IA ainsi qu'une base de données pour détecter et bloquer automatiquement
          les contenus haineux, racistes ou inappropriés avant affichage.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>Streaming Twitter temps réel :</strong> Optimisation des performances
          pour gérer un flux continu de tweets avec la Twitter API tout en maintenant
          une latence minimale pour l'expérience RP.
        </Typography>
        <Typography variant="body2">
          <strong>Expérience utilisateur immersive :</strong> Design et intégration
          soignés pour que l'affichage des tweets s'intègre naturellement dans
          l'univers RP sans briser l'immersion des joueurs.
        </Typography>
      </Box>
    </Box>
  );
};

export default CrazyTownProject;




